import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { Select } from "react-input-textboxs";
import Header from "../../Components/Header/Header";
import {
  Button,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core/";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  fetchUserReport,
  setPageName,
  getHourlyReport,
  getRecordingPendingReport,
  getCSVFILE,
  fetchProducts,
} from "./../../service/action/audio-track-action";
import { Loader, DatePicker } from "./../../Components";

const csvFileName = {
  "Translation Audit Details": "RPT-GET-Translation-Audit-Details",
  "Translation Details": "RPT-GET-Translation-Details",
  "Recording Details": "RPT-GET-RecordingDetails",
  "Recording Audit Details": "RPT-GET-RecordingAuditDetails",
  "Rejected Record Details": "RPT-GET-RejectedRecordDetails",
  "Transcripted Details": "RPT-GET-TranscriptDetails",
  "Keyword Report Date Based": "Keyword-Report-DateBased",
};

const flags = [
  { label: "All", value: "0" },
  { label: "Unique", value: "1" },
];

//const cordGredient = ['pink-blue', 'skyblue-royalblue', 'green-yellow', 'yellow-red', 'green-blue', 'blue-grey', 'pink-green', 'dark-blue-light-blue']

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: {
        startDate: "",
        endDate: "",
      },
      csvButton: "",
      searchValue: "0",
      flagValue: "",
      selectAllProducts: true,
      remoteAdd: 'appserver.armsoft-tech.com'
      // remoteAdd:'10.101.1.248'
    };
    this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
  }

  componentWillMount() {
    //this.props.fetchUserReport()
    this.props.fetchProducts();
    this.props.setPageName("Report");
  }

  handleDateChange(value, key) {
    const { filterValues } = this.state;
    filterValues[key] = value === null ? "" : value;
    this.setState({ filterValues });
  }
  // renderCards(list) {
  //     const _cards = list.map((data, i) => {
  //         return (
  //             <ReportCardTile
  //                 key={i}
  //                 classes={cordGredient[i]}
  //                 name={data.user}
  //                 total={data.total}
  //                 completed={data.completed}
  //             />
  //         )
  //     })

  //     return _cards;
  // }

  renderUserReport(list) {
    const _cards = list.map((data, i) => {
      return (
        <li key={i} className="report-table-row">
          <span className="table-data">{data.user}</span>
          <span className="table-data">{data.completed}</span>
          <span className="table-data">{data.total}</span>
        </li>
      );
    });
    return _cards;
  }

  handleSelectAllProducts = (event) => {
    console.log(event.target.value);
    if (event.target.value === "0") {
      this.setState({
        selectAllProducts: true,
        searchValue: "0",
      });
    } else {
      this.setState({
        selectAllProducts: false,
      });
    }
  };

  handleSearchValueChange(event, value) {
    event.preventDefault();
    const {
      SuperAdminReducer: { userProducts },
    } = this.props;
    console.log(userProducts);
    console.log(value);
    const userObj = value.map((item) => {
      return (
        userProducts &&
        userProducts.find((element) => element.Productdesc === item)
      );
    });
    console.log(userObj);
    if (userObj.length > 0) {
      const productIds = userObj.map((element) => {
        return element.ProductId;
      });
      console.log(productIds.toString());
      this.setState({
        searchValue: productIds.toString(),
      });
    } else {
      this.setState({ searchValue: "0" });
    }
  }

  handleFlagValueChange(event, value) {
    event.preventDefault();
    console.log(value);
    const userObj =
      (flags && flags.find((element) => element.label === value)) || null;
    // console.log(userObj.user_id);
    if (userObj === null) {
      this.setState({ flagValue: "" });
    } else {
      this.setState({ flagValue: userObj.value });
    }
  }

  downloadCSVFile() {
    const {
      csvButton,
      filterValues: { startDate, endDate },
      flagValue,
      searchValue,
      remoteAdd
    } = this.state;
    let start_date = "";
    let end_date = "";
    if (startDate !== "" && endDate !== "") {
      if(csvButton === 'Translation Audit Details'){
        let sdate = new Date(startDate);
        let edate = new Date(endDate);
        start_date = `${sdate.getFullYear()}-${
          sdate.getMonth() + 1
        }-${sdate.getDate()}`;
        end_date = `${edate.getFullYear()}-${
          edate.getMonth() + 1
        }-${edate.getDate()}`;
      }else{
        let sdate = new Date(startDate);
        let edate = new Date(endDate);
        start_date = `${sdate.getFullYear()}-${
          sdate.getMonth() + 1
        }-${sdate.getDate()} 00:00:00`;
        end_date = `${edate.getFullYear()}-${
          edate.getMonth() + 1
        }-${edate.getDate()} 23:59:59`;
        
      }
    }
    const _fileToBeDownloaded = Object.entries(csvFileName).filter(
      (_filds) => csvButton === _filds[0]
    );

    console.log(flagValue, searchValue);

    this.props.getCSVFILE(
      _fileToBeDownloaded[0][1],
      start_date,
      end_date,
      flagValue,
      searchValue,
      remoteAdd
    );
  }
  render() {
    const {
      adminDashBoard: { userReport, downloadReport },
      SuperAdminReducer: { userProducts },
    } = this.props;
    const {
      csvButton,
      filterValues,
      searchValue,
      flagValue,
      selectAllProducts,
    } = this.state;
    console.log(csvButton, searchValue, flagValue, selectAllProducts);
    return (
      <div className="right-section">
        <div className="parentTable">
          <Header page="Reports" />
          <div className="admin-report">
            <nav className="audioLink">
              <ul>
                <li>
                  <Link to="/verifyaudio"> {/* <li>Verify Audio</li> */}</Link>
                </li>
                {/* <li><button onClick={()=>this.props.getHourlyReport()} className="btn download-btn">Hourly report</button></li>
                        <li><button onClick={()=>this.props.getHourlyReport()} className="btn download-btn">Hourly based quality check status</button></li>
                        <li><button onClick={()=>this.props.getHourlyReport()} className="btn download-btn">Hourly based audio recording status</button></li> */}
              </ul>
              <ul className="download-btn-wrapper">
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport("get-hourly-report")
                    }
                    className="btn download-btn"
                  >
                    Hourly report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-quality-check-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Hourly based quality check status
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-audio-recording-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Hourly based audio recording status
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport("get-user-wise-keyword")
                    }
                    className="btn download-btn"
                  >
                    User wise keyword
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport("get-keyword-wise-count")
                    }
                    className="btn download-btn"
                  >
                    Keyword wise count
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-audio-audit-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Audio audit hourly report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-audio-recorded-not-audited-keyword-count"
                      )
                    }
                    className="btn download-btn"
                  >
                    Not audited keyword count
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-audio-audited-correctly-keyword-count"
                      )
                    }
                    className="btn download-btn"
                  >
                    Audited keyword count
                  </button>
                </li>

                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-super-audit-today-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Super Audit Today Hourly Report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-super-audit-yesterday-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Super Audit Yesterday Hourly Report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-audio-audit-yesterday-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Audio Audit Yesterday Hourly Report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-audio-recording-yesdterday-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Audio Recording Yesdterday Hourly Report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-daily-rejected-accepted-details"
                      )
                    }
                    className="btn download-btn"
                  >
                    Daily Rejected Accepted Details
                  </button>
                </li>

                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-transcript-yesdterday-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Transcript Yesterday Hourly Report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getHourlyReport(
                        "get-transcript-audit-yesdterday-hourly-report"
                      )
                    }
                    className="btn download-btn"
                  >
                    Transcript Audit Yesdterday Hourly Report
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      this.props.getRecordingPendingReport(
                        "Userwise-Record-PendingCount"
                      )
                    }
                    className="btn download-btn"
                  >
                    Recording Pending Details
                  </button>
                </li>
              </ul>
            </nav>

            <div className="admin-form">
              <div className="userInput">
                <Autocomplete
                  // value={searchValue}
                  onChange={(event, newValue) =>
                    this.setState({
                      csvButton: newValue,
                    })
                  }
                  id="controllable-states-demo1"
                  options={Object.keys(csvFileName)}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select from list..."
                      // variant="outlined"
                      style={{ width: "80%", marginTop: "-20px" }}
                    />
                  )}
                />
                <DatePicker
                  control="date"
                  label="Start Date"
                  keys="startDate"
                  value={
                    filterValues.startDate === ""
                      ? null
                      : filterValues.startDate
                  }
                  format="MM/dd/yyyy"
                  handleDateChange={(value, key) =>
                    this.handleDateChange(value, key)
                  }
                  // style={{ width: "80%", top: "-50px" }}
                />
                <DatePicker
                  control="date"
                  label="End Date"
                  keys="endDate"
                  value={
                    filterValues.endDate === "" ? null : filterValues.endDate
                  }
                  format="MM/dd/yyyy"
                  handleDateChange={(value, key) =>
                    this.handleDateChange(value, key)
                  }
                  // style={{ top: "-50px" }}
                />

                {csvButton === "Recording Details" ||
                csvButton === "Recording Audit Details" ? (
                  <>
                    <FormControl
                      component="fieldset"
                      style={{ width: "60%", top: "30px" }}
                    >
                      <FormLabel component="legend">Select Products</FormLabel>
                      <RadioGroup
                        aria-label="products"
                        name="products"
                        onChange={this.handleSelectAllProducts}
                        defaultValue="0"
                      >
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="All"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Select From List"
                        />
                      </RadioGroup>
                    </FormControl>
                  </>
                ) : (
                  <div className="btn-wrapper">
                    <Button
                      disabled={
                        csvButton !== "" &&
                        filterValues.endDate !== "" &&
                        filterValues.startDate !== ""
                          ? false
                          : true
                      }
                      onClick={() => this.downloadCSVFile()}
                      variant="contained"
                      color="primary"
                    >
                      Submit
                    </Button>
                  </div>
                )}
              </div>
              <br />
              <br />
              <div className="userInput">
                {(csvButton === "Recording Details" ||
                  csvButton === "Recording Audit Details") &&
                selectAllProducts === false ? (
                  <>
                    <Autocomplete
                      onChange={(event, newValue) =>
                        this.handleFlagValueChange(event, newValue)
                      }
                      id="controllable-states-demo1"
                      options={
                        flags && flags.length > 0
                          ? flags.map((option) => option.label)
                          : []
                      }
                      style={{ width: "50%" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select a value..."
                          style={{ width: "80%", marginTop: "-20px" }}
                        />
                      )}
                    />
                    <Autocomplete
                      onChange={(event, newValues) =>
                        this.handleSearchValueChange(event, newValues)
                      }
                      multiple
                      id="controllable-states-demo"
                      options={
                        userProducts && userProducts.length > 0
                          ? userProducts.map((option) => option.Productdesc)
                          : []
                      }
                      style={{ width: "50%" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Products"
                          // variant="outlined"
                          style={{ width: "80%", marginTop: "-20px" }}
                        />
                      )}
                    />
                    <div className="btn-wrapper">
                      <Button
                        disabled={
                          csvButton !== "" &&
                          flagValue !== "" &&
                          filterValues.endDate !== "" &&
                          filterValues.startDate !== ""
                            ? false
                            : true
                        }
                        onClick={() => this.downloadCSVFile()}
                        variant="contained"
                        color="primary"
                      >
                        Submit
                      </Button>
                    </div>
                  </>
                ) : (
                  (csvButton === "Recording Details" ||
                    csvButton === "Recording Audit Details") &&
                  selectAllProducts === true && (
                    <>
                      <Autocomplete
                        onChange={(event, newValue) =>
                          this.handleFlagValueChange(event, newValue)
                        }
                        id="controllable-states-demo1"
                        options={
                          flags && flags.length > 0
                            ? flags.map((option) => option.label)
                            : []
                        }
                        style={{ width: "50%" }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select a value..."
                            style={{ width: "80%", marginTop: "-20px" }}
                          />
                        )}
                      />
                      <div className="btn-wrapper">
                        <Button
                          disabled={
                            csvButton !== "" &&
                            flagValue !== "" &&
                            filterValues.endDate !== "" &&
                            filterValues.startDate !== ""
                              ? false
                              : true
                          }
                          onClick={() => this.downloadCSVFile()}
                          variant="contained"
                          color="primary"
                        >
                          Submit
                        </Button>
                      </div>
                    </>
                  )
                )}
              </div>
              {downloadReport.loading === true ? (
                <p
                  style={{
                    display: "flex",
                    color: "#ca750a",
                    justifyContent: "center",
                    fontSize: 22,
                  }}
                >
                  {" "}
                  CSV file Preparing for download
                </p>
              ) : downloadReport.loading === false ? (
                <p
                  style={{
                    display: "flex",
                    color: "#008000",
                    justifyContent: "center",
                    fontSize: 22,
                  }}
                >
                  {" "}
                  CSV file Downloaded
                </p>
              ) : null}
            </div>
            {/* <ul className="report-table">
                    <li className="report-table-row">
                        <span className="table-header">Name/ID</span>
                        <span className="table-header">Completed</span>
                        <span className="table-header">Total</span>
                    </li>
                    {this.renderUserReport(userReport)}
                </ul> */}
            {/* <div className={`people-report ${userReport.length % 2 === 0 ? '' : 'first-full-tiles'}`}>

                    
                    {this.renderCards(userReport)}
                </div> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    AudioToTrackReducer,
    userLogin,
    adminDashBoard,
    loading,
    page,
    SuperAdminReducer,
  } = state;
  return {
    AudioToTrackReducer,
    userLogin,
    adminDashBoard,
    loading,
    page,
    SuperAdminReducer,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchUserReport: () => dispatch(fetchUserReport()),
  fetchProducts: () => dispatch(fetchProducts()),
  setPageName: (a) => dispatch(setPageName(a)),
  getHourlyReport: (type) => dispatch(getHourlyReport(type)),
  getRecordingPendingReport: (type) =>
    dispatch(getRecordingPendingReport(type)),
  getCSVFILE: (URL, startDate, endDate, flagValue, searchValue,REMOTE_ADDR) =>
    dispatch(getCSVFILE(URL, startDate, endDate, flagValue, searchValue,REMOTE_ADDR)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Report));
